<template>
  <div class="selectBrand">
    <div class="selectBrand__header">
      <div class="header__icon">
        <PinSvg />
      </div>
      <h1>Escolha uma marca</h1>
    </div>

    <div>
      <VInput v-model="searchedBrand" :placeholder="`Digite o nome da marca`" />
    </div>

    <div class="selectBrand__list" v-if="brandList">
      <ul class="list__card">
        <li v-for="(unit) in brandList" :key="unit.idUnidade"
          :class="['card__item', { 'item--selected': unit.brandId === brandSelected.brandId }]"
          @click="brandSelection(unit)">
          <div class="item__title" v-html="unit.name"></div>
        </li>
      </ul>
    </div>

    <div class="selectBrand__button">
      <VButton text="Continuar" :disabled="continueButtonAction"
        @click.native="continueToCheckIn()" />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { LOCAL_STORAGE_BRAND_ID } from '@/utils/constants/checkin.constants';

export default {
  name: 'SelectBrand',
  data: () => ({
    continueButtonAction: true,
    unitsList: null,
    brandSelected: {},
    isGeolocalActive: false,
    listError: false,
    searchedBrand: '',
  }),
  computed: {
    ...mapState({
      brands: ({ brands }) => brands,
    }),
    brandList() {
      const brands = Object.entries(this.brands)
        .filter(([key, value]) => value.collaboratorVaccineCampaign && value.name.toLowerCase().includes(this.searchedBrand.toLowerCase()))
        .map(([key, value]) => ({
          brandId: key,
          name: value.name,
          url: value.urlName,
          logo: value.logo,
        }));

      return brands;
    }
  },
  methods: {
    ...mapMutations({
      setCurrentBrandVariables: 'SET_CURRENT_BRAND_NAME_ID',
    }),

    brandSelection(unit) {
      this.brandSelected = unit;
      this.continueButtonAction = false;
    },

    /**
     * @method continueToCheckIn
     * @description
     * Triggers route push and sets unitId in store
     */
    continueToCheckIn() {
      this.setCurrentBrandVariables({ brandId: this.brandSelected.brandId });
      localStorage.setItem(LOCAL_STORAGE_BRAND_ID, this.brandSelected.brandId);

      const brand = this.brandSelected.url;
      this.$router.push({ name: 'select-unit', params: { brandName: brand } });
    }
  },
};
</script>

<style lang="scss">
.selectBrand {
  max-width: 420px;
  height: 100%;
  margin: 0 auto;
  overflow: hidden;

  &__header {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: 12px;

    h1 {
      padding-left: 18px;
      font-size: var(--font-size-4);
      font-weight: bold;
    }

    .header__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      width: 40px;
      border-radius: 8px;
      background-color: var(--color-primary-transparency);

      svg {
        fill: var(--color-primary);
        width: 15px;
        height: 20px;
      }
    }
  }

  .list__card {
    max-height: 82vh;
    padding-bottom: 88px;
    overflow-y: auto;

    .card__item {
      display: flex;
      flex-direction: row;
      position: relative;
      align-items: flex-start;
      width: 100%;
      padding: 16px;
      margin-top: 16px;
      border: 1px solid #1616161F;
      border-radius: 4px;
      text-align: left;
      cursor: pointer;

      .item {

        &__title {
          font-size: var(--font-size-3);
          font-weight: bold;
          max-width: 78%;
        }

        &__logo {

          & svg {
            max-height: 40px;
          }
        }
      }

      @media (max-width: 320px) {
        padding: 10px;

        .item {

          &__link {
            padding: 8px 0 0;
          }

          &__title {
            font-size: var(--font-size-2);
            width: 76%;
          }
        }
      }
    }

    .item--selected {
      background-color: var(--color-primary-transparency);
      border: 1px solid var(--color-primary);
      transition: 0.5s ease-in-out;
    }
  }

  .selectBrand__button {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 24px 16px;
    max-width: inherit;
    margin: 0 auto;
  }
}
</style>
